import { ReactNode } from "react";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./PolicyIconContainer.module.scss";

type PolicyIconContainerProps = {
  children: ReactNode;
  className?: string;
};

const PolicyIconContainer = ({ children, className }: PolicyIconContainerProps) => (
  <span className={formatClassNames(styles.container, className)} aria-hidden="true">
    {children}
  </span>
);

export default wrapperHOC(PolicyIconContainer, {
  componentName: "PolicyIconContainer-PropertyPage",
  showForChina: true,
});
